<template>
  <Element
    :section="section"
    type="element"
    class="headline paragraph"
    :class="{'element-hidden': !visability()}"
    @delete="$emit('delete')"
    @dublicate="$emit('dublicate')"
    @favorite="$emit('favorite', $el)"
    @flow="handleFlow"
    @move-to="to => $emit('move-to', to)"
    @add-subject="$emit('add-subject')"
    @click.stop.native="sectionSettings()"
    @highlight-click="contentClick"
  >
    <ContentEditableV4
      ref="content"
      :sid="section.sid"
      :content="section.options.content"
      :readonly="!canUpdatePages"
      :resolution="resolutioner"
      @input="section.options.content = $event"
    />
  </Element>
</template>

<script>
import SectionMixin from '@builder/components/mixins/SectionMixin'
import Element from '@/components/builder/utils/Element.vue'
import ContentEditableV4 from '@/components/builder/utils/ContentEditableV4.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'ElFlexText',
  mixins: [SectionMixin],
  components: {
    ContentEditableV4,
    Element
  },
  computed: {
    ...mapGetters('projects', {
      checkPermissions: 'checkPermissions'
    }),
    canUpdatePages () {
      return this.checkPermissions('pages.update')
    }
  },
  methods: {
    contentClick () {
      this.$refs.content.initer()
    }
  }
}
</script>
